<template>
    <div class="account-input" :class="{ error: errorMessage }">
        <label class="account-input__label" v-if="title" :for="name">{{ title }}</label>
        <slot></slot>
        <div class="account-input__error" v-html="errorMessage"></div>
    </div>
</template>

<script setup lang="ts">
import { watch } from "vue";

const emit = defineEmits(["inputErrorDetected"]);

const props = defineProps<{
    name: string;
    errorMessage?: string;
    title?: string;
}>();

watch(
    () => props.errorMessage,
    (newErrorMessage) => {
        if (newErrorMessage) emit("inputErrorDetected");
    }
);
</script>
